import { App } from 'vue'
import Option from '../select/src/option.vue'

Option.install = (app:App) => {
  app.component(Option.name, Option)
}

export default Option

declare module 'vue' {
  export interface GlobalComponents {
    PtOption: typeof Option;
  }
}
